import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { PwaUserService } from '../services/user/pwa-user.service';

@Injectable()
export class OrganizationUserResolver implements Resolve<any> {
  constructor(private userService: PwaUserService) {
  }

  resolve() {
    return this.userService.getCurrentUser();
  }
}
